import { Component, OnInit, Input, EventEmitter, OnChanges, Output } from '@angular/core';

// Import's externos:
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-header-comfenalco',
  templateUrl: './header-comfenalco.component.html',
  styleUrls: ['./header-comfenalco.component.css']
})
export class HeaderComfenalcoComponent implements OnInit, OnChanges {

  @Input() public listaEmpresas : ObjetoFiltroEmpresas[] = [];

  @Output() public objetoReporteComfenalco : EventEmitter<ObjetoParametrosFiltro>;

  public activeAllCheck : boolean = false;

  public getActiveAllCheck() {
    if(this.activeAllCheck == true) {
      this.activeAllCheck = false;
    } else {
      this.activeAllCheck = true;
    }
  }

  private objetoParametrosFiltros : ObjetoParametrosFiltro = {
    uncoEmpresa : "",
    fechaInicial : null,
    fechaFinal : null
  }

  public dpConfig : Partial<BsDatepickerConfig> = new BsDatepickerConfig();

  constructor( private localeServiceEs : BsLocaleService ) {
    this.dpConfig.containerClass = "theme-default";
    this.dpConfig.dateInputFormat = "DD/MM/YYYY";
    this.localeServiceEs.use( "es" );

    this.objetoReporteComfenalco = new EventEmitter();
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getListaEmpresas();
    this.getObjetoReporteComfenalco();
  }

  public getObjetoReporteComfenalco() {
    this.objetoReporteComfenalco.emit( this.objetoParametrosFiltros );
  }

  public getFechaInicio( fecha : Date ) {
    if( fecha != null ) {
      this.objetoParametrosFiltros.fechaInicial = fecha;
    }
  }

  public getFechaFinal( fecha : Date ) {
    if( fecha != null ) {
      this.objetoParametrosFiltros.fechaFinal = fecha;
    }
  }

  public getEmpresa( empresa : ObjetoFiltroEmpresas, event : any ) {

    for (let i = 0; i < this.listaEmpresas.length; i++) {
      if(  event.target.checked ) {
        if( this.listaEmpresas[i].descripcionCorta == empresa.descripcionCorta ) {
          this.objetoParametrosFiltros.uncoEmpresa  += this.listaEmpresas[i].unco + ",";
        }
      } else {
        if( this.listaEmpresas[i].descripcionCorta == empresa.descripcionCorta ) {
          this.objetoParametrosFiltros.uncoEmpresa = this.objetoParametrosFiltros.uncoEmpresa.replace(this.listaEmpresas[i].unco +",", "");
        }
      }
    }
  }
  public getAllEmpresas( event : any ) {
    if(  event.target.checked ) {
      for (let i = 0; i < this.listaEmpresas.length; i++) {
        this.objetoParametrosFiltros.uncoEmpresa += this.listaEmpresas[i].unco + ","
      }
    } else {
      this.objetoParametrosFiltros.uncoEmpresa = "";
    }
  }

  private async getListaEmpresas() {
    try {
      await this.listaEmpresas;
    }catch(exception) {
      console.log(exception);
    }
  }

}

interface ObjetoFiltroEmpresas {
  unco : number,
  descripcionCorta : string
}

interface ObjetoParametrosFiltro {
  uncoEmpresa : string,
  fechaInicial : Date,
  fechaFinal : Date
}
